import React from "react";
import Link from "gatsby-link";
import "./ProductCard.css";

const ProductCard = ({ item, isHighlighted }) => {
  const productUrl = `/products/Detail?${item.type}&${item.urlName.replace(/ /g, "-") || item.productName.replace(/ /g, "-")}`;

  return (
    <div className={`card-wrapper ${isHighlighted ? "card-wrapper--highlighted" : ""}`}>
      <Link to={productUrl} className="product-card">
        <div className={`product-card__container ${isHighlighted ? "product-card__container--highlighted" : ""}`}>
          <div className="product-card__image-wrapper">
            <div className="product-card__image">
              <img
                src={item.imgUrl || item.imgUrls[0]}
                alt={item.productName}
                loading="lazy"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/fallback-product-image.jpg"; // Add a fallback image path
                }}
              />
            </div>
          </div>
          <div className="product-card__content">
            <h3 className="product-card__title" title={item.productName}>
              {item.productName}
            </h3>
          </div>
          <div className="product-card__overlay">
            <span className="product-card__cta">View Details</span>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ProductCard;



// WEBPACK FOOTER //
// ./src/components/ProductCards/ProductCard.js